import {QuoteWizardDefaultViewController} from '../../../quoteWizardDefaultView.controller';

export class MailingAddressController extends QuoteWizardDefaultViewController {
    public goNext() {
        if (this.stateService.viewModel.clientStateContext.submissionRequest.mailingAddress.state === 'MO'
            && angular.isDefined(this.stateService.viewModel.questionResponseGraph.cancelledCoverage.response)) {
            this.stateService.viewModel.questionResponseGraph.cancelledCoverage.response = undefined;
        }
        super.goNext();
    }
}